import React, { useState, useEffect } from "react";
import { User, Menu } from "lucide-react";
import "./Header.css";
import { useNavigate } from "react-router-dom";

const Header = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(localStorage.getItem("user_name") || "");
  const [userProfile, setUserProfile] = useState(localStorage.getItem("user_profile") || "");

  const updateHeaderData = () => {
    setUserName(localStorage.getItem("user_name") || "");
    setUserProfile(localStorage.getItem("user_profile") || "");
  };

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "user_name" || e.key === "user_profile") {
        updateHeaderData();
      }
    };

    window.addEventListener("profileUpdated", updateHeaderData);
    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("profileUpdated", updateHeaderData);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <header className="main-header">
      <div className="header-content">
        <div className="header-left">
          <button className="menu-toggle" onClick={toggleSidebar}>
            <Menu size={20} />
          </button>
          <div className="header-title">
            <h3>QPAY EMPLOYEE</h3>
          </div>
        </div>
        <div className="header-right">
          <div
            className="header-profile"
            onClick={() => {
              navigate("/profile");
            }}
          >
            {userProfile && userProfile !== "null" ? (
              <img
                src={userProfile}
                alt={userName || "Profile"}
                height={32}
                width={32}
                style={{ objectFit: "contain", borderRadius: "50%" }}
              />
            ) : (
              <div className="profile-icon">
                <User size={32} />
              </div>
            )}
            <span className="profile-name">{userName || "Employee"}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
